(function () {
    'use strict';

    angular
        .module('franchisee-portal.components')
        .controller('ArtsSolicitationInternalController', ArtsSolicitationInternalController);

    /** @ngInject */
    function ArtsSolicitationInternalController($scope, $stateParams, $rootScope, $state, $q, HelperService, HelpdeskService, AuthenticationService, UnitService, NotifyService, sweetAlert, DATA_EVENTS) {
        const vm = this;

        let ticketOriginalData = {};
        let ticketStatusOriginalData;
        let ticketArtThemeOriginalData;
        let ticketArtTypesOriginalData;

        let userData;
        let lastResponse;

        // SYSTEM DEFAULT METHODS
        // vm.uiCanExit = () => {
        //     return HelperService.uiCanExit([
        //         ticketOriginalData,
        //         ticketCategoryOriginalData,
        //         ticketStatusOriginalData
        //     ], [
        //         vm.artData,
        //         vm.selectedCategory,
        //         vm.selectedStatus
        //     ]);
        // }

        // vm.isDataModified = () => {
        //     return vm.artData.Id && (
        //         !angular.equals(vm.artData, ticketOriginalData) ||
        //         !angular.equals(vm.selectedCategory, ticketCategoryOriginalData) ||
        //         !angular.equals(vm.selectedStatus, ticketStatusOriginalData)
        //     );
        // }

        // vm.resetForm = () => {
        //     angular.copy(ticketOriginalData, vm.artData);
        //     angular.copy(ticketCategoryOriginalData, vm.selectedCategory);
        //     angular.copy(ticketStatusOriginalData, vm.selectedStatus);
        // }

        // ÁREA CUSTOM METHODS
        vm.isArtModified = (isEdit = false) => {
            if (!isEdit) {
                return vm.artData.Id &&
                    !angular.equals(vm.selectedStatus, ticketStatusOriginalData) ||
                    vm.response != null;
            }

            return vm.artData.Id &&
                !angular.equals(vm.artData, ticketOriginalData) ||
                !angular.equals(vm.selectedArtTheme, ticketArtThemeOriginalData) ||
                !angular.equals(vm.selectedArtTypes, ticketArtTypesOriginalData);
        }

        vm.isArtClosed = () => {
            if (!vm.artData.IsClosed)
                return;

            return vm.artData.IsClosed;
        }

        vm.hasEditPermission = () => {
            if (!vm.artData.Id)
                return true;

            let hasPermission = false;

            if (vm.artData.TicketCategory) {
                let categoryPerson = vm.artData.TicketCategory.TicketCategory_Person;

                for (let index = 0; index < categoryPerson.length; index++) {
                    if (categoryPerson[index].PersonId == userData.Id)
                        hasPermission = true;
                }
            }

            return hasPermission;
        }

        vm.changeSolicitationType = isChange => {
            if (!vm.artData.TicketExtraData)
                vm.artData.TicketExtraData = {};

            vm.artData.TicketExtraData.Change = isChange;
        }

        vm.flowFileAdded = $file => {
            let blacklist = ['exe', 'bat', 'com', 'sis', 'dll', 'js', 'msi', 'cmd', 'hta', 'scr', 'pif', 'reg', 'vbs', 'wsf', 'cpl', 'jar'];
            let extension = $file.getExtension();

            if (blacklist.includes(extension)) {
                HelperService.setErrorMessageForm('.file', 'Formato inválido.');
                return false;
            }

            HelperService.removeErrorMessageForm('.file');
        }

        vm.flowFileFinished = ($file, $message) => {
            var message = angular.fromJson($message);
            let file = {
                TicketId: vm.artData.Id,
                Name: message.FileName,
                Url: message.FileSaveName
            };

            HelperService.startLoading('.loading-holder');

            saveTicketAttachments(file)
                .then(
                    success => {
                        file.Id = success.Id;
                        vm.files.push(file);

                        vm.artData.Attachment = file;
                        vm.saveResponse();
                    }, error => errorCallback(error)
                );
        }

        vm.deleteFile = file => {
            sweetAlert.swal({
                title: 'Você tem certeza?',
                text: 'Não é possível desfazer essa ação!',
                type: 'warning',
                confirmButtonText: 'Sim, tenho certeza',
                showCancelButton: true,
                cancelButtonText: 'Não, cancelar',
                allowOutsideClick: false,
                allowEscapeKey: false
            }).then(response => {
                if (response.value) {
                    HelperService.startLoading('.loading-holder');

                    HelpdeskService
                        .deleteAttachment(file.Id, file.Url)
                        .then(() => {
                            var index = vm.files.indexOf(file);

                            if (index != -1)
                                vm.files.splice(index, 1);

                            vm.artData.Attachment = file;
                            vm.artData.Attachment.Deleted = true;
                            vm.saveResponse();

                            ticketOriginalData = angular.copy(vm.artData);
                        }, error => {
                            HelperService.errorCallback(error);
                            HelperService.stopLoading('.loading-holder');
                        })
                }
            })
        }

        vm.getFileIcon = file => {
            return HelperService.imageHandlerFileIcon(file.Url.split('.').pop());
        }

        vm.getFileUrl = file => {
            return HelperService.fileFolderPath(`art-solicitation/${vm.artData.Id}`, file.Url);
        }

        vm.saveArt = () => {
            if (!vm.selectedArtTheme) {
                HelperService.setErrorMessageForm('.theme');
                return;
            }

            if (!vm.selectedArtTypes.length) {
                HelperService.setErrorMessageForm('.art', 'Selecione pelo menos um tipo de arte.');
                return;
            }

            HelperService.startLoading('.loading-holder');

            vm.artData.TicketExtraData.TicketExtraData_ArtType = vm.selectedArtTypes.reduce((acc, cur) => {
                acc.push({
                    TicketExtraDataId: vm.artData.TicketExtraData.Id,
                    ArtTypeId: cur.ArtType.Id,
                    Width: cur.Width,
                    Height: cur.Height
                })

                return acc;
            }, [])

            let artData = angular.copy(vm.artData);

            if (!vm.artData.Id) {
                let unitData = AuthenticationService.getSelectedUnit();

                if (!vm.artData.CallerPhone)
                    vm.artData.CallerPhone = '';

                artData.Title = `Solicitação de Artes - ${userData.Name}`;
                artData.TicketCategoryId = 2;
                artData.PersonId = userData.Id;
                artData.UnitId = unitData.Id;
                artData.UnitFantasyName = unitData.FantasyName;
                artData.UnitExternalCode = unitData.ExternalCode;

                vm.response = 'Abertura de solicitação de arte.';

                artData.TicketExtraData.ArtRequestThemeId = vm.selectedArtTheme.Id;
                artData.TicketExtraData.ArtRequestTypeId = artData.TicketExtraData.Change ? 2 : 1

                artData.TicketExtraData = [artData.TicketExtraData];

                artData.TicketTimeline = [{
                    TicketStatusId: 1,
                    PersonId: AuthenticationService.getUserId(),
                    Text: vm.response
                }];

                if (vm.artData.TicketExtraData.PromotionExpirationDateFormatted) {
                    let date = angular.copy(vm.artData.TicketExtraData.PromotionExpirationDateFormatted.replace(/[//"]/g, '-'));
                    let dateSplitted = date.split("-");

                    date = `${dateSplitted[2]}-${dateSplitted[1]}-${dateSplitted[0]}`;
                    artData.TicketExtraData.PromotionExpirationDate = date;
                }

                HelpdeskService
                    .postTicket(artData)
                    .then(success => successCallback(success, false, true), errorCallback);
            } else {
                if (vm.artData.TicketExtraData.PromotionExpirationDateFormatted) {
                    let date = angular.copy(vm.artData.TicketExtraData.PromotionExpirationDateFormatted.replace(/[//"]/g, '-'));
                    let dateSplitted = date.split("-");

                    date = `${dateSplitted[2]}-${dateSplitted[1]}-${dateSplitted[0]}`;
                    artData.TicketExtraData.PromotionExpirationDate = date;
                }

                artData.TicketExtraData.ArtRequestThemeId = vm.selectedArtTheme.Id;
                artData.TicketExtraData.ArtRequestTypeId = artData.TicketExtraData.Change ? 2 : 1

                artData.TicketExtraData = [artData.TicketExtraData];

                HelpdeskService
                    .putTicket(artData)
                    .then(vm.saveResponse(), errorCallback);
            }
        }

        vm.saveResponse = (showLoading = false) => {
            if (showLoading)
                HelperService.startLoading('.loading-holder');

            let timeline = {
                TicketId: vm.artData.Id,
                TicketStatusId: vm.selectedStatus.Id,
                PersonId: AuthenticationService.getUserId()
            };

            let text = "";

            if (vm.artData.Attachment) {
                if (!vm.artData.Attachment.Deleted)
                    text = text.concat(`<p>Novo anexo adicionado: <b>${vm.artData.Attachment.Name}</b></p>`);
                else
                    text = text.concat(`<p>Anexo deletado: <b>${vm.artData.Attachment.Name}</b></p>`);
            }

            if (!angular.equals(lastResponse.TicketStatusId, vm.selectedStatus.Id)) {
                let oldStatus = vm.status.find(x => x.Id == lastResponse.TicketStatusId);
                text = text.concat(`<p>Status alterado de: <b>${oldStatus.Title}</b> para: <b>${vm.selectedStatus.Title}</b></p>`);
            }

            if (!angular.equals(vm.artData.TicketExtraData.Change, ticketOriginalData.TicketExtraData.Change))
                text = text.concat(`<p>Tipo de solicitação alterado de: <b>${ticketOriginalData.TicketExtraData.Change ? 'Alteração' : 'Criação'}</b> para: <b>${vm.artData.TicketExtraData.Change ? 'Alteração' : 'Criação'}</b></p>`);

            if (!angular.equals(vm.selectedArtTypes, ticketArtTypesOriginalData)) {
                let newArtTypes = vm.selectedArtTypes.reduce((acc, cur) => {
                    if (acc.length > 1)
                        acc = `${acc} - ${cur.ArtType.Name} (${cur.Width} x ${cur.Height})`;
                    else
                        acc = `${cur.ArtType.Name} (${cur.Width} x ${cur.Height})`;

                    return acc;
                }, '');

                let oldArtTypes = ticketArtTypesOriginalData.reduce((acc, cur) => {
                    if (acc.length > 1)
                        acc = `${acc} - ${cur.ArtType.Name} (${cur.Width} x ${cur.Height})`;
                    else
                        acc = `${cur.ArtType.Name} (${cur.Width} x ${cur.Height})`;

                    return acc;
                }, '');

                text = text.concat(`<p>Artes alteradas de: <b>${oldArtTypes}</b> para: <b>${newArtTypes}</b></p>`);
            }

            if (!angular.equals(vm.artData.TicketExtraData.ArtRequestThemeId, vm.selectedArtTheme.Id))
                text = text.concat(`<p>Tema alterado de: <b>${ticketOriginalData.TicketExtraData.ArtRequestTheme.Description}</b> para: <b>${vm.selectedArtTheme.Description}</b></p>`);

            if (!angular.equals(vm.artData.TicketExtraData.PromotionDescription, ticketOriginalData.TicketExtraData.PromotionDescription))
                text = text.concat(`<p>Promoção alterada de: <b>${ticketOriginalData.TicketExtraData.PromotionDescription ? ticketOriginalData.TicketExtraData.PromotionDescription : '-'}</b> para: <b>${vm.artData.TicketExtraData.PromotionDescription}</b></p>`);

            if (!angular.equals(vm.artData.TicketExtraData.AdditionalInformation, ticketOriginalData.TicketExtraData.AdditionalInformation))
                text = text.concat(`<p>Informações complementares alteradas de: <b>${ticketOriginalData.TicketExtraData.AdditionalInformation ? ticketOriginalData.TicketExtraData.AdditionalInformation : '-'}</b> para: <b>${vm.artData.TicketExtraData.AdditionalInformation}</b></p>`);

            if (!angular.equals(vm.artData.TicketExtraData.Regulation, ticketOriginalData.TicketExtraData.Regulation))
                text = text.concat(`<p>Regulamento alterado de: <b>${ticketOriginalData.TicketExtraData.Regulation ? ticketOriginalData.TicketExtraData.Regulation : '-'}</b> para: <b>${vm.artData.TicketExtraData.Regulation}</b></p>`);

            if (!angular.equals(vm.artData.TicketExtraData.Reference, ticketOriginalData.TicketExtraData.Reference))
                text = text.concat(`<p>Referência alterada de: <b>${ticketOriginalData.TicketExtraData.Reference ? ticketOriginalData.TicketExtraData.Reference : '-'}</b> para: <b>${vm.artData.TicketExtraData.Reference}</b></p>`);

            if (!angular.equals(vm.artData.TicketExtraData.PromotionExpirationDate, ticketOriginalData.TicketExtraData.PromotionExpirationDate))
                text = text.concat(`<p>Data de validade alterada de: <b>${ticketOriginalData.TicketExtraData.PromotionExpirationDate ? ticketOriginalData.TicketExtraData.PromotionExpirationDate : '-'}</b> para: <b>${vm.artData.TicketExtraData.PromotionExpirationDate}</b></p>`);

            if (vm.response)
                text = text.concat(vm.response);

            timeline.Text = text;

            HelpdeskService
                .postTimeline(timeline, userData.Id)
                .then(success => successCallback(success, true), error => errorCallback(error));
        }

        vm.closeArt = () => {
            sweetAlert.swal({
                title: 'Você tem certeza?',
                text: 'Não é possível desfazer essa ação!',
                type: 'warning',
                confirmButtonText: 'Sim, tenho certeza',
                showCancelButton: true,
                cancelButtonText: 'Não, cancelar',
                allowOutsideClick: false,
                allowEscapeKey: false
            }).then(response => {
                if (response.value) {
                    HelperService.startLoading('.loading-holder');

                    let timeline = {
                        TicketId: vm.artData.Id,
                        TicketStatusId: 4,
                        PersonId: AuthenticationService.getUserId(),
                        Text: '<p><b>SOLICITAÇÃO FECHADA PELO FRANQUEADO.</b></p>'
                    };

                    if (userData.Id != vm.artData.PersonId)
                        timeline.Text = '<p><b>SOLICITAÇÃO FECHADA.</b></p>';

                    HelpdeskService
                        .postTimeline(timeline, userData.Id)
                        .then(success => {
                            let newResponse = {
                                Id: success.Id,
                                Person: userData,
                                Text: success.Text,
                                RegistrationDate: success.RegistrationDate
                            };

                            vm.timeline.unshift(newResponse);

                            vm.artData.IsClosed = true;

                            NotifyService.success("Solicitação fechada com sucesso.");
                            HelperService.stopLoading('.loading-holder');
                        }, error => errorCallback(error));
                }
            })
        }

        vm.openUnitModal = () => {
            HelperService.startLoading('.loading-holder');

            getUnit(vm.artData.UnitId)
                .then(() => {
                    $('#unitModal').modal('show');

                    HelperService.stopLoading('.loading-holder');
                });
        }

        /**********
        ART TYPES
        **********/

        vm.getNumber = num => {
            let retArray = [];

            for (let i = 0; i < num; i++)
                retArray.push(i);

            return retArray;
        }

        vm.addArtType = () => {
            vm.numberOfArts++;
        }

        vm.removeArtType = index => {
            vm.numberOfArts--;

            vm.selectedArtTypes.splice(index, 1);
        }

        vm.isArtRemovable = index => {
            return index > 0;
        }

        vm.isRequired = index => {
            let isRequired = false;

            if (vm.selectedArtTypes[index] && (vm.selectedArtTypes[index].ArtType || vm.selectedArtTypes[index].Width || vm.selectedArtTypes[index].Height))
                isRequired = true;

            return isRequired;
        }

        let removeWatchUnit = $rootScope.$on(DATA_EVENTS.SELECTED_UNIT_CHANGE, () => {
            init();
        })

        $scope.$on('$destroy', () => {
            removeWatchUnit();
        })

        init();

        function saveTicketAttachments(attachment) {
            return HelpdeskService
                .postAttachment(attachment);
        }

        function getTicket() {
            const artSolicitationId = $stateParams.artSolicitationId;
            const personId = AuthenticationService.getUserId();

            if (!artSolicitationId) {
                vm.artData.CallerName = userData.Name;
                vm.artData.CallerEmail = userData.Email;
                vm.artData.CallerPhone = userData.Phone;

                ticketOriginalData = angular.copy(vm.artData);
                HelperService.stopLoading('.loading-holder');

                $('#info-modal').modal('show');
                
                return;
            }

            HelpdeskService
                .getById(artSolicitationId, personId)
                .then(success => {
                    vm.artData = success;

                    vm.artData.RegistrationDateFormatted = moment(vm.artData.RegistrationDate).format('DD-MM-YYYY H:mm:ss');

                    lastResponse = vm.artData.TicketTimeline[vm.artData.TicketTimeline.length - 1];

                    if (lastResponse) {
                        vm.selectedStatus = vm.status.find(x => x.Id == lastResponse.TicketStatusId);
                        vm.artData.AtualizationDateFormatted = moment(lastResponse.RegistrationDate).format('DD-MM-YYYY H:mm:ss');
                    }

                    if (vm.selectedStatus.Id == 4)
                        vm.artData.IsClosed = true;

                    if (vm.artData.TicketAttachment.length)
                        vm.files = vm.artData.TicketAttachment;

                    if (vm.artData.TicketTimeline.length)
                        vm.timeline = angular.copy(vm.artData.TicketTimeline.reverse());

                    if (vm.artData.TicketExtraData.length) {
                        vm.artData.TicketExtraData = vm.artData.TicketExtraData[0];

                        if (vm.artData.TicketExtraData.PromotionExpirationDate)
                            vm.artData.TicketExtraData.PromotionExpirationDateFormatted = moment(vm.artData.TicketExtraData.PromotionExpirationDate).format('DD-MM-YYYY');

                        if (vm.artData.TicketExtraData.ArtRequestTypeId)
                            vm.artData.TicketExtraData.Change = (vm.artData.TicketExtraData.ArtRequestTypeId == 2);

                        if (vm.artData.TicketExtraData.ArtRequestThemeId)
                            vm.selectedArtTheme = vm.themes.find(theme => theme.Id == vm.artData.TicketExtraData.ArtRequestThemeId);

                        if (vm.artData.TicketExtraData.TicketExtraData_ArtType.length) {
                            vm.selectedArtTypes = vm.artData.TicketExtraData.TicketExtraData_ArtType;
                            vm.numberOfArts = vm.artData.TicketExtraData.TicketExtraData_ArtType.length;
                        }
                    }

                    ticketOriginalData = angular.copy(vm.artData);
                    ticketStatusOriginalData = angular.copy(vm.selectedStatus);
                    ticketArtThemeOriginalData = angular.copy(vm.selectedArtTheme);
                    ticketArtTypesOriginalData = angular.copy(vm.selectedArtTypes);

                    HelperService.stopLoading('.loading-holder');
                }, error => {
                    HelperService.errorCallback(error);
                    HelperService.stopLoading('.loading-holder');
                })
        }

        function getStatus() {
            return HelpdeskService
                .getAllStatus()
                .then(success => {
                    vm.status = success;
                }, error => {
                    HelperService.errorCallback(error);
                })
        }

        function getArtTypes() {
            return HelpdeskService
                .getAllArtTypes()
                .then(
                    success => vm.artTypes = success,
                    error => HelperService.errorCallback(error)
                );
        }

        function getArtRequestThemes() {
            return HelpdeskService
                .getAllArtRequestThemes()
                .then(success => {
                    vm.themes = success;
                }, error => {
                    HelperService.errorCallback(error);
                })
        }

        function getArtRequestTypes() {
            return HelpdeskService
                .getAllArtRequestTypes()
                .then(success => {
                    vm.types = success;
                }, error => {
                    HelperService.errorCallback(error);
                })
        }

        function getUnit(unitId) {
            return UnitService
                .get(unitId)
                .then(success => {
                    if (success.Unit_Address.length)
                        success.Unit_Address = success.Unit_Address[0];
                    else
                        success.Unit_Address = null;

                    if (success.Unit_Document.length)
                        success.Unit_Document = success.Unit_Document.find(x => x.DocumentTypeId == 5);
                    else
                        success.Unit_Document = null;

                    if (success.Unit_Email.length)
                        success.Unit_Email = success.Unit_Email[0];
                    else
                        success.Unit_Email = null;

                    if (success.Unit_Phone.length)
                        success.Unit_Phone = success.Unit_Phone.find(x => x.Code && x.Number);
                    else
                        success.Unit_Phone = null;

                    vm.unitData = success;
                }, error => {
                    HelperService.errorCallback(error);
                })
        }

        function successCallback(success, isAtualization = false, isPost = false) {
            if (isPost) {
                HelperService.successCallback();

                vm.artData = success;

                ticketOriginalData = angular.copy(vm.artData);
                ticketStatusOriginalData = angular.copy(vm.selectedStatus);
                ticketArtThemeOriginalData = angular.copy(vm.selectedArtTheme);
                ticketArtTypesOriginalData = angular.copy(vm.selectedArtTypes);

                $state.go('app-master.default.arts-solicitation-internal', {
                    artSolicitationId: vm.artData.Id
                }, {
                    notify: false
                });
            } else {
                if (isAtualization) {
                    let newResponse = {
                        Id: success.Id,
                        Person: userData,
                        Text: success.Text,
                        RegistrationDate: success.RegistrationDate
                    };

                    vm.timeline.unshift(newResponse);
                }

                vm.response = null;

                ticketOriginalData = angular.copy(vm.artData);
                ticketStatusOriginalData = angular.copy(vm.selectedStatus);
                ticketArtThemeOriginalData = angular.copy(vm.selectedArtTheme);
                ticketArtTypesOriginalData = angular.copy(vm.selectedArtTypes);

                NotifyService.success("Solicitação atualizada com sucesso. Aguarde uma nova interação.");
            }

            HelperService.stopLoading('.loading-holder');
        }

        function errorCallback(error) {
            HelperService.stopLoading('.loading-holder');
            HelperService.errorCallback(error);
        }

        function init() {           

            userData = AuthenticationService.getUserData();
            lastResponse = {};

            vm.artData = {};
            vm.selectedDate = {};
            vm.selectedArtTheme = null;
            vm.selectedArtTypes = [];
            vm.numberOfArts = 1;
            vm.files = [];

            vm.flowOptions = {
                query: function () {
                    return {
                        Path: `art-solicitation/${vm.artData.Id}`
                    }
                }
            }

            angular.extend(vm.flowOptions, HelperService.getFlowOptionsDefaultsFile());

            HelperService.startLoading('.loading-holder');

            $q.all([getStatus(), getArtTypes(), getArtRequestThemes(), getArtRequestTypes()])
                .then(() => {
                    getTicket();
                })
        }
    }
}());